import { Component, ViewChild, ElementRef, OnInit } from '@angular/core';
import { AppService } from 'src/app/app.service';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { SuccessSnackbarComponent } from 'src/app/support/success-snackbar/success-snackbar.component';
import { PaginationService } from 'src/app/PaginationService';
import { messageService } from 'src/app/message.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { StaticAuditTrailComponent } from 'src/app/support/static-audit-trail/static-audit-trail.component';
import { ExcelPdfComponent } from 'src/app/support/excel-pdf/excel-pdf.component';
import { MatOption } from '@angular/material/core';
import { MatSelect } from '@angular/material/select';

export interface PopupData {
  title: string;
}

@Component({
  selector: 'app-tms-settings',
  templateUrl: './tms-settings.component.html',
  styleUrls: ['./tms-settings.component.scss']
})

export class TmsSettingsComponent implements OnInit {

  isProcessing = true;
  organizationDetails: any;
  allowedFileExtnsSearchText: any = "";
  allSelected = false;
  allCoreBusinessSelected = false;
  @ViewChild('reasonForChange') reasonForChange: MatSelect;
  toggleAllSelection(value: any) {
    if (value == 'reasonForChange') {
      if (this.allSelected) {
        this.reasonForChange.options.forEach((item: MatOption) => item.select());
      } else {
        this.reasonForChange.options.forEach((item: MatOption) => item.deselect());
      }
    }

  }
  allowedFileExtnList: any;
  allowedFileExtnListMethod() {

    if (!this.organizationDetails?.allowedFileExtns) {
      console.warn('organizationDetails or allowedFileExtns missing');
      return;
    }

    const list = this.organizationDetails.allowedFileExtns.split(",");
    this.allowedFileExtnList = list.map((e: string) => ({
      valueExp: e.trim(),
      displayExp: e.trim()
    }));

  }
  constructor(public dialog: MatDialog, private readonly appService: AppService, public router: Router, private readonly snackBar: MatSnackBar,
    public paginationService: PaginationService, public message: messageService, private readonly elem: ElementRef) { }

  tmsSettingsList: any;
  tmsSettingsObj: any = {};
  isTmsSettingsDataEmpty: any;
  dropDownForReportTimezone: any = [];
  selectedTimeZone: any = null;
  timeZoneDropdown: any = [];
  popupDataTitle: PopupData = {
    title: ''
  };
  oddTimezone: any = null;
  ngOnInit() {
    this.isProcessing = true;
    this.dropDownForReportTimezone = JSON.parse(sessionStorage.getItem('dropDownForReportTimezone') ?? '{}');
    this.selectBoxForTimeZone();
    this.appService.getTmsSettingsVwDetails().subscribe({
      next: (response: any) => {
        if (response == null) {
          this.tmsSettingsList = response;
          this.tmsSettingsObj = {};
          this.isTmsSettingsDataEmpty = true;
          this.isProcessing = false;
        } else {
          this.tmsSettingsList = response;
          this.tmsSettingsList.esignatureAtTrainingUnlock = this.tmsSettingsList.esignatureAtTrainingUnlock == "Y";
          this.tmsSettingsList.esignatureAtTrainingCompletion = this.tmsSettingsList.esignatureAtTrainingCompletion == "Y";
          this.tmsSettingsList.markTrainingCompletedForDocumentActionPerformers = this.tmsSettingsList.markTrainingCompletedForDocumentActionPerformers == "Y";
          if (this.tmsSettingsList.reportsTimezone) {
            const matchingTimeZone = this.dropDownForReportTimezone?.find((item: any) => item.codelistCode == this.tmsSettingsList.reportsTimezone);
            if (!matchingTimeZone) {
              this.oddTimezone = this.tmsSettingsList.reportsTimezone;
              this.timeZoneDropdown.push({
                valueExp: this.tmsSettingsList.reportsTimezone,
                displayExp: this.tmsSettingsList.reportsTimezone
              })
            }
            this.selectedTimeZone = this.tmsSettingsList.reportsTimezone;
          }
          this.tmsSettingsObj = this.tmsSettingsList;
          if (this.tmsSettingsObj.trainingContentExtns != null) {
            this.tmsSettingsObj.selectedAllowedFileExtns = this.tmsSettingsObj.trainingContentExtns.split(",");
          }
          this.isTmsSettingsDataEmpty = false;
          this.isProcessing = false;
        }
      }, error: (error) => {
        throw error;
      }
    });

    this.appService.getOneQmsOrganization().subscribe((data: any) => {
      this.organizationDetails = data;
      this.allowedFileExtnListMethod();
    });
  }

  focusmethod(value: any) {
    setTimeout(() => {
      let requiredElement = document.getElementById(value);
      requiredElement?.focus();
    }, 0)
  }

  focusSearch(value: any) {
    setTimeout(() => {
      let searchBox = document.getElementById(value);
      searchBox?.focus();
    }, 0)
  }

  refreshForm() {
    this.ngOnInit();
  }

  selectBoxForTimeZone() {
    this.timeZoneDropdown = [];
    this.timeZoneDropdown = this.dropDownForReportTimezone?.map((item: any) => ({
      valueExp: item.codelistCode,
      displayExp: item.codelistName
    }))
  }

  reportsTimezonesearchTxt: any;

  onReportsTimezoneSelect(event: any, item: any) {
    if (event.isUserInput) {
      if (event.source._selected) {
        this.selectedTimeZone = item.valueExp;
      } else {
        this.selectedTimeZone = undefined;
      }
    }
  }

  singleSelectDropdownSetting: IDropdownSettings = {
    idField: 'valueExp',
    textField: 'displayExp',
    enableCheckAll: false,
    allowSearchFilter: true,
    singleSelection: true,
    itemsShowLimit: 1,
  };

  tmsSettingsFieldData: any = {};
  operationFlag: any;
  popupTitle: any;

  validateNumberFields(event: KeyboardEvent) {
    const forbiddenKeys = ['E', 'e', '-', '*', '+', '.'];
    if (forbiddenKeys.includes(event.key)) {
      event.preventDefault();
    }
  }

  openSnackbar: any;
  displayMessage: any;
  errorStatus: any;
  displayResultType: any;
  displaySuccessMessage: boolean;
  displayErrorMessage: boolean;
  saveTmsSettings(tmsSettingsObj: any) {
    if (this.isTmsSettingsDataEmpty) {
      this.isProcessing = true;
      tmsSettingsObj.esignatureAtTrainingUnlock = tmsSettingsObj.esignatureAtTrainingUnlock ? "Y" : "N";
      tmsSettingsObj.esignatureAtTrainingCompletion = tmsSettingsObj.esignatureAtTrainingCompletion ? "Y" : "N";
      tmsSettingsObj.reportsTimezone = this.selectedTimeZone ?? null;
      tmsSettingsObj['trainingContentExtns'] = tmsSettingsObj['selectedAllowedFileExtns']?.join(",");
      tmsSettingsObj.markTrainingCompletedForDocumentActionPerformers = tmsSettingsObj.markTrainingCompletedForDocumentActionPerformers ? "Y" : "N";
      this.appService.createTmsSettingsDetails(tmsSettingsObj).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.ngOnInit();
          }
          this.isProcessing = false;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: this.displayResultType == 'S' ? 5000 : undefined,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
              pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }, error: (error) => {
          throw error;
        }
      });
    } else {
      this.isProcessing = true;
      delete tmsSettingsObj['createdOn'];
      delete tmsSettingsObj['updatedOn'];
      tmsSettingsObj['trainingContentExtns'] = tmsSettingsObj['selectedAllowedFileExtns']?.join(",");
      let data = {
        ...tmsSettingsObj,
        esignatureAtTrainingUnlock: tmsSettingsObj.esignatureAtTrainingUnlock ? "Y" : "N",
        esignatureAtTrainingCompletion: tmsSettingsObj.esignatureAtTrainingCompletion ? "Y" : "N",
        markTrainingCompletedForDocumentActionPerformers: tmsSettingsObj.markTrainingCompletedForDocumentActionPerformers ? "Y" : "N",
        reportsTimezone: this.selectedTimeZone ?? null,
      }
      this.appService.updateTmsSettingsDetails(data).subscribe({
        next: (Response: any) => {
          this.displayMessage = Response.result;
          this.displayResultType = Response.resultType;
          if (this.displayResultType == 'S') {
            this.ngOnInit();
          }
          this.isProcessing = false;
          let sb = this.snackBar.openFromComponent(SuccessSnackbarComponent, {
            duration: this.displayResultType == 'S' ? 5000 : undefined,
            data: {
              message: Response.result,
              type: Response.resultType == 'S' ? 'Success' : 'Error',
              buttonLabel: "Ok",
              pageName: this.message.breadcrumbData.thirdLevel ?? this.message.breadcrumbData.secondLevel
            },
            horizontalPosition: 'center',
            verticalPosition: 'top',
            panelClass: Response.resultType == 'S' ? 'Success' : 'Error',
          });
          sb.onAction().subscribe(() => {
            sb.dismiss();
          });
        }, error: (error) => {
          throw error;
        }
      });
    }
  }

  @ViewChild(StaticAuditTrailComponent) staticAuditTrailComponent!: StaticAuditTrailComponent;

  openAuditTrail() {
    this.message.tableOrView_Name = "TMS_SETTINGS_AU_VW";
    this.message.columnList_DB = "CREATED_TS,END_TS,ACTION_FLAG,ESIGNATURE_AT_TRAINING_UNLOCK,ESIGNATURE_AT_TRAINING_COMPLETION,MARK_TRAINING_COMPLETED_FOR_DOCUMENT_ACTION_PERFORMERS,REPORTS_TIMEZONE,NO_OF_ALLOWED_TRAININGS_IN_A_DAY,TRAINING_CONTENT_EXTNS,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON";
    this.message.columnList_UI = "Created Timestamp,End Timestamp,Action Flag,Esignature at Training Unlock?,Esignature at Training Completion?,Mark Training Completed for Document Action Performers?,Reports Timezone,No of Allowed Trainings (In Days),Training Content Extensions,Created On,Created By User,Updated On,Updated By User,Update Reason";
    this.message.whereClause_AU = "";
    this.message.columnList_Report = "Created Timestamp,End Timestamp,Action Flag,Esignature at Training Unlock?,Esignature at Training Completion?,Mark Training Completed for Document Action Performers?,Reports Timezone,No of Allowed Trainings (In Days),Training Content Extensions,Created On,Created By User,Updated On,Updated By User,Update Reason";
    this.message.whereClause_Report = "";
    this.message.report_And_Popup_Name = "Trainings Settings Audit Trail";
    this.staticAuditTrailComponent.triggerTrail(0);
  }

  @ViewChild(ExcelPdfComponent) excelPdfComponent!: ExcelPdfComponent;
  excelPdf: any = {};

  openReport(reportType: string) {
    this.excelPdf.tableOrView_Name = "TMS_SETTINGS_VW";
    this.excelPdf.columnList_DB = "ESIGNATURE_AT_TRAINING_UNLOCK,ESIGNATURE_AT_TRAINING_COMPLETION,MARK_TRAINING_COMPLETED_FOR_DOCUMENT_ACTION_PERFORMERS,REPORTS_TIMEZONE,NO_OF_ALLOWED_TRAININGS_IN_A_DAY,TRAINING_CONTENT_EXTNS,CREATED_ON,CREATED_BY_USER,UPDATED_ON,UPDATED_BY_USER,UPDATE_REASON";
    this.excelPdf.columnList_Report = "Esignature at Training Unlock?,Esignature at Training Completion?,Mark Training Completed for Document Action Performers?,Reports Timezone,No of Allowed Trainings (In Days),Training Content Extensions,Created On,Created By User,Updated On,Updated By User,Update Reason";
    this.excelPdf.whereClause_Report = '';
    this.excelPdf.reportType = 'Static';
    this.excelPdf.reportName = 'Trainings Settings Report';
    this.excelPdf.dropDown = this.excelPdf.columnList_Report?.split(',');
    this.excelPdfComponent.openReportPopup(reportType);
  }

}




